// src/Tiptap.tsx
import { ListItem } from "@tiptap/extension-list-item";
import { liftListItem, sinkListItem, splitListItem } from "@tiptap/pm/schema-list";

const CustomListItem = ListItem.extend({
    addKeyboardShortcuts() {
        return {
            Enter: ({ editor }) => {
                const { state } = editor;
                const { selection } = state;
                const { $from } = selection;
                const node = $from.node();

                if (node.type.name === "listItem" && node.content.size === 0) {
                    return liftListItem(editor.schema.nodes.listItem)(
                        editor.state,
                        editor.view.dispatch,
                    );
                }

                return splitListItem(editor.schema.nodes.listItem)(state, editor.view.dispatch);
            },

            Tab: ({ editor }) => {
                sinkListItem(editor.schema.nodes.listItem)(editor.state, editor.view.dispatch);
                return true; // ✅ Always return true to prevent default browser behavior
            },

            "Shift-Tab": ({ editor }) => {
                liftListItem(editor.schema.nodes.listItem)(editor.state, editor.view.dispatch);
                return true; // ✅ Always return true here too
            },
        };
    },
});

export default CustomListItem;